var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64286 0.428589C4.27889 0.428589 2.97078 0.970424 2.00631 1.9349C1.04184 2.89937 0.5 4.20748 0.5 5.57145V20.4286C0.5 21.7926 1.04184 23.1007 2.00631 24.0651C2.97078 25.0296 4.27889 25.5714 5.64286 25.5714H27.3571C28.7211 25.5714 30.0292 25.0296 30.9937 24.0651C31.9582 23.1007 32.5 21.7926 32.5 20.4286V5.57145C32.5 4.20748 31.9582 2.89937 30.9937 1.9349C30.0292 0.970424 28.7211 0.428589 27.3571 0.428589H5.64286ZM30.2143 6.60345L16.5 13.9874L2.78571 6.60345V5.57145C2.78571 4.81368 3.08673 4.08696 3.62255 3.55114C4.15837 3.01532 4.8851 2.7143 5.64286 2.7143H27.3571C28.1149 2.7143 28.8416 3.01532 29.3774 3.55114C29.9133 4.08696 30.2143 4.81368 30.2143 5.57145V6.60345ZM2.78571 9.19887L15.9583 16.2926C16.1248 16.3822 16.3109 16.4291 16.5 16.4291C16.6891 16.4291 16.8752 16.3822 17.0417 16.2926L30.2143 9.19887V20.4286C30.2143 21.1864 29.9133 21.9131 29.3774 22.4489C28.8416 22.9847 28.1149 23.2857 27.3571 23.2857H5.64286C4.8851 23.2857 4.15837 22.9847 3.62255 22.4489C3.08673 21.9131 2.78571 21.1864 2.78571 20.4286V9.19887Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.fa530ab1817c1a0842a41ebbd112374f.svg";
export { ForwardRef as ReactComponent };